import { render, staticRenderFns } from "./Pbr.vue?vue&type=template&id=5398e7aa"
import script from "./Pbr.vue?vue&type=script&lang=js"
export * from "./Pbr.vue?vue&type=script&lang=js"
import style0 from "./Pbr.vue?vue&type=style&index=0&id=5398e7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports